require('./brokerProductUserInfo.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const classnames = require('classnames');
const moment = require('moment');
// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { formatWithoutRound } = require('utilities/currencyHelper');
const { valueOrHyphen, conditionalValueOrHyphen } = require('utilities/valueHelper');
const DateHelper = require('utilities/dateHelper');
// @ commons
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
// @constants
const {
    EURO_TEXT,
    HYPHEN,
    DATE_FORMAT_API,
    DATE_FORMAT_DAY_MONTH_SHORT,
    DATE_FORMAT_SHORT_TIME_24
} = require('constants/index');

class BrokerProductUserInfo extends React.Component {
    buildAmountCurrency(amount, currency) {
        return (
            <span>
                <span className="broker-product-user-info__amount">{amount} </span>
                <span className="broker-product-user-info__currency">{currency}</span>
            </span>
        );
    }

    buildAmountCurrencyEur(amount, currency) {
        return (
            <span className="broker-product-user-info__second-row-eur">
                <span className="broker-product-user-info__amount-eur">{amount} </span>
                <span className="broker-product-user-info__currency-eur">{currency}</span>
            </span>
        );
    }

    buildAveragePriceEurLabelFor(immStock) {
        const averagePrice = immStock.getIn(['averagePriceEur','amount']);
        const averagePriceCurrency = immStock.getIn(['averagePriceEur','currency']);
        const averagePriceFormatted = formatWithoutRound(averagePrice, 3);
        return (this.buildAmountCurrencyEur(averagePriceFormatted, averagePriceCurrency));
    }

    buildAveragePriceLabelFor(immStock) {
        const averagePrice = immStock.get('averagePrice');
        const averagePriceCurrency = immStock.get('averagePriceCurrency');
        if (!averagePriceCurrency) {
            return <span>{HYPHEN}</span>;
        }
        const averagePriceFormatted = formatWithoutRound(averagePrice, 3);
        return (this.buildAmountCurrency(averagePriceFormatted, averagePriceCurrency));
    }

    buildFormattedQuoteDate(immStock) {
        const quoteDate = immStock.get('quoteDate');
        const quoteTime = immStock.get('quoteTime');

        const parsedQuoteDate = moment(quoteDate, DATE_FORMAT_API);
        const parsedQuoteTime = moment(quoteTime, 'HH:mm:ss');

        const formattedQuoteDate =
            parsedQuoteDate.isValid() ?
            DateHelper.buildFormattedDate(parsedQuoteDate, DATE_FORMAT_DAY_MONTH_SHORT) :
            HYPHEN;

        const formattedQuoteTime =
            parsedQuoteTime.isValid() ?
            DateHelper.buildFormattedDate(parsedQuoteTime, DATE_FORMAT_SHORT_TIME_24) :
            HYPHEN;

        const quoteDateIsToday = moment().isSame(parsedQuoteDate, 'day');

        if (quoteDateIsToday) {
            const todayLabel = formatText('broker-todayMyInvestmentsProductsTable');
            return `${todayLabel}, ${formattedQuoteTime}`;
        } else {
            return `${formattedQuoteDate}, ${formattedQuoteTime}`;
        }
    }

    buildHeader() {
        const contract = formatText('broker-myInvestmentsWrappedProductsTableContractLabel');
        const titles = formatText('broker-productSharesStocks');
        const price = formatText('broker-productAveragePrice');
        const capital = formatText('broker-productInvestedCapital');
        const quotation = formatText('broker-productNATStocks');
        const actualValue = formatText('broker-productSharesActualValue');
        const profitability = formatText('broker-productEarnings');
        const inWallet = formatText('broker-productInWallet');

        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className="col-xs-6 col-lg-3 broker-product-user-info__wrapper">
                        <div className="col-xs-6 col-lg-8 broker-product-user-info__contract">
                            <span className="broker-product-user-info__info">
                                {contract}
                            </span>
                        </div>

                        <div className="col-xs-6 col-lg-4 broker-product-user-info__titles">
                            <span className="broker-product-user-info__columnn-with-sign broker-product-user-info__info">
                                {titles}
                            </span>
                        </div>
                    </div>

                    <div className="col-xs-6 col-lg-3 broker-product-user-info__wrapper">
                        <div className="col-xs-6 col-lg-6 broker-product-user-info__half-price">
                            <span className="broker-product-user-info__info">
                                {price}
                            </span>
                        </div>

                        <div className="col-xs-6 col-lg-6 broker-product-user-info__capital-invested">
                            <span className="broker-product-user-info__info">
                                {capital}
                            </span>
                        </div>
                    </div>

                    <div className="col-xs-6 col-lg-5 broker-product-user-info__wrapper-quotation">
                        <div className="col-xs-6 col-lg-4 broker-product-user-info__quotation">
                            <span className="broker-product-user-info__info">
                                {quotation}
                                <OKTooltip
                                    content="broker-stocksQuoteInfoTooltip"
                                    offset={[0, -15]}
                                />
                            </span>
                        </div>

                        <div className="col-xs-6 col-lg-3 broker-product-user-info__actual-value">
                            <span className="broker-product-user-info__columnn-with-sign broker-product-user-info__info">
                                {actualValue}
                            </span>
                        </div>

                        <div className="col-xs-6 col-lg-5 broker-product-user-info__profitability">
                            <span className="broker-product-user-info__info">
                                {profitability}
                            </span>
                        </div>
                    </div>

                    <div className="col-xs-6 col-lg-1 broker-product-user-info__in-wallet">
                        <span className="broker-product-user-info__info">
                            {inWallet}
                        </span>
                    </div>
                </div>
            </div>
        );
    }

    buildInvestmentEurLabelFor(immStock) {
        const investmentEur = immStock.getIn(['investmentEur','amount']);
        const profitabilityEur = immStock.getIn(['earningsEur','amount']);
        if (investmentEur == null || profitabilityEur == null) {
            return <FormattedText value="broker-myInvestmentsNotAvailableInitials"/>;
        }

        const investmentFormatted = formatWithoutRound(investmentEur, 2);
        const investmentFormattedCurrency = immStock.getIn(['investmentEur','currency']);

        return (this.buildAmountCurrencyEur(investmentFormatted, investmentFormattedCurrency));
    }

    buildInvestmentLabelFor(immStock) {
        const investment = immStock.get('investment');
        const profitability = immStock.get('earnings');

        if (investment == null || profitability == null) {
            return <FormattedText value="broker-myInvestmentsNotAvailableInitials"/>;
        }

        const investmentFormatted = formatWithoutRound(investment, 2);
        const investmentFormattedCurrency = immStock.get('investmentCurrency');

        return this.buildAmountCurrency(investmentFormatted, investmentFormattedCurrency);
    }

    buildProfitability(amountCurrency, percentage) {
        return (
            <div className="broker-product-user-info__earnings-row">
                {amountCurrency}
                <span className="broker-product-user-info__earnings-separator">|</span>
                <span className="broker-product-user-info__earnings-percentage">
                    {percentage}%
                </span>
            </div>
        );
    }

    buildProfitabilityEurLabelFor(immStock) {
        const profitabilityEur = immStock.getIn(['earningsEur', 'amount']);
        const investmentEur = immStock.getIn(['investmentEur', 'amount']);

        if (profitabilityEur == null || investmentEur == null) {
            return <FormattedText value="broker-myInvestmentsNotAvailableInitials"/>;
        }

        const percentageEur = immStock.get('profitablePercentageEuros');
        const currencyEur = immStock.getIn(['earningsEur','currency']);

        const profitabilityPercentage = formatWithoutRound(percentageEur, 2);
        const profitabilityFormatted = formatWithoutRound(profitabilityEur, 2);
        const amountCurrencyEur = this.buildAmountCurrencyEur(profitabilityFormatted, currencyEur);
        return this.buildProfitability(amountCurrencyEur, profitabilityPercentage);
    }

    buildProfitabilityLabelFor(immStock) {
        const profitability = immStock.get('earnings');
        const investment = immStock.get('investment');

        if (profitability == null || investment == null) {
            return <FormattedText value="broker-myInvestmentsNotAvailableInitials"/>;
        }

        const percentage = immStock.get('profitablePercentage');
        const currency = immStock.get('earningsCurrency');

        const profitabilityPercentage = formatWithoutRound(percentage, 2);
        const profitabilityFormatted = formatWithoutRound(profitability, 2);
        const amountCurrency = this.buildAmountCurrency(profitabilityFormatted, currency);
        return this.buildProfitability(amountCurrency, profitabilityPercentage);
    }

    buildQuoteAmount(quoteObject) {
        if (quoteObject.amount===null) {
            return <span>{HYPHEN}</span>;
        }
        const quoteAmountFormatted = formatWithoutRound(quoteObject.amount, 3);
        return (this.buildAmountCurrency(quoteAmountFormatted, quoteObject.currency));
    }

    buildQuoteAmountEur(quoteObjectEur) {
        if (quoteObjectEur.amount===null) {
            return <span>{HYPHEN}</span>;
        }
        const quoteAmountFormatted = formatWithoutRound(quoteObjectEur.amount, 3);
        return this.buildAmountCurrencyEur(quoteAmountFormatted, quoteObjectEur.currency);
    }

    buildTotalValue(operations, prefix = '') {
        const totalValue = operations.get('totalValue');
        const valueCurrency = (
            <span className="broker-product-user-info__unconsolidated-values-currency">
                {operations.get('totalValueCurrency')}
            </span>
        );
        const decimalTotalValue = formatWithoutRound(totalValue, 2);
        const formattedTotalValue = `${prefix}${decimalTotalValue}`;
        return this.buildAmountCurrency(formattedTotalValue, valueCurrency);
    }

    buildUnconsolidatedOperationsActualValue(immStock) {
        const hasUnconsolidatedOperations = immStock.getIn(['unconsolidatedOperations', 'hasUnconsolidatedOperations']);

        if (!hasUnconsolidatedOperations) {
            return null;
        }

        const unconsolidatedOperations = immStock.get('unconsolidatedOperations');
        const unconsolidatedValuesValue = unconsolidatedOperations.get('totalValue');
        const isZero = unconsolidatedValuesValue == 0 ? true : false;
        const isNegative = unconsolidatedValuesValue < 0 ? true : false;
        const columnWithoutSign = classnames({
            'broker-product-user-info__columnn-with-sign': isZero,
            'broker-product-user-info__columnn-with-sign--negative': isNegative,
        });
        let unconsolidatedParsedValue;

        if (!isZero && !isNegative) {
            unconsolidatedParsedValue = this.buildTotalValue(unconsolidatedOperations, '+');
        } else {
            unconsolidatedParsedValue = this.buildTotalValue(unconsolidatedOperations);
        }

        const unconsolidatedValue = conditionalValueOrHyphen(unconsolidatedValuesValue != null, unconsolidatedParsedValue);

        return (
            <span className={columnWithoutSign}>
                {unconsolidatedValue}
            </span>
        );
    }

    buildUnconsolidatedOperationsShares(immStock) {
        const hasUnconsolidatedOperations = immStock.getIn(['unconsolidatedOperations', 'hasUnconsolidatedOperations']);

        if (!hasUnconsolidatedOperations) {
            return null;
        }

        const unconsolidatedOperations = immStock.get('unconsolidatedOperations');
        const unconsolidatedSharesValue = unconsolidatedOperations.get('shares');
        const isZero = unconsolidatedSharesValue == 0 ? true : false;
        const isNegative = unconsolidatedSharesValue < 0 ? true : false;
        const columnWithoutSign = classnames({
            'broker-product-user-info__columnn-with-sign': isZero,
            'broker-product-user-info__columnn-with-sign--negative': isNegative,
        });
        let unconsolidatedValue = valueOrHyphen(unconsolidatedSharesValue);

        if (!isZero && !isNegative) {
            unconsolidatedValue = '+' + unconsolidatedValue;
        }

        return (
            <span className={columnWithoutSign}>
                {unconsolidatedValue}
            </span>
        );
    }

    buildUnconsolidatedOperationsTotalActualValue(immStock) {
        const hasUnconsolidatedOperations = immStock.getIn(['unconsolidatedOperations', 'hasUnconsolidatedOperations']);

        if (!hasUnconsolidatedOperations) {
            return null;
        }

        const totalOperations = immStock.get('totalOperations');
        const totalOperationsValuesValue = totalOperations.get('totalValue');
        const totalValue = conditionalValueOrHyphen(totalOperationsValuesValue != null, this.buildTotalValue(totalOperations));
        return totalValue;
    }

    buildUnconsolidatedOperationsTotalShares(immStock) {
        const hasUnconsolidatedOperations = immStock.getIn(['unconsolidatedOperations', 'hasUnconsolidatedOperations']);

        if (!hasUnconsolidatedOperations) {
            return null;
        }

        const totalOperations = immStock.get('totalOperations');
        const totalOperationsSharesValue = totalOperations.get('shares');
        const totalValue = valueOrHyphen(totalOperationsSharesValue);
        return totalValue;
    }

    buildUserInfo(immStock) {
        const { noBottomButtons } = this.props;
        const hasUnconsolidatedOperations = immStock.getIn(['unconsolidatedOperations', 'hasUnconsolidatedOperations']);
        const contractForTooltip = immStock.get('contractForTooltip');
        const shares = immStock.get('shares');
        const formattedShares = formatWithoutRound(shares);
        const quote = immStock.get('quote');
        const quoteCurrency = immStock.get('quoteCurrency');
        const quoteEur = immStock.getIn(['quoteEur','amount']);
        const quoteCurrencyEur = immStock.getIn(['quoteEur','currency']);
        const value = formatWithoutRound(immStock.get('totalValue'), 2);
        const valueCurrency = immStock.get('totalValueCurrency');
        const valueEur = formatWithoutRound(immStock.getIn(['totalValueEur','amount']), 2);
        const valueCurrencyEur = immStock.getIn(['totalValueEur','currency']);
        const percentageInWallet = immStock.get('percentageInWallet');
        const notQuoteEur = quoteCurrency && quoteCurrency !== EURO_TEXT ? true : false;
        const userValuesClassNames = classnames(
            'broker-product-user-info__item',
            {
            'broker-product-user-info__buttonless': noBottomButtons,
            'broker-product-user-info__not-eur-currency': notQuoteEur,
            'broker-product-user-info__user-values': !hasUnconsolidatedOperations
        });
        const averagePriceBlock = this.buildAveragePriceLabelFor(immStock);
        const formattedInvestment = this.buildInvestmentLabelFor(immStock);
        const formattedEarnings = this.buildProfitabilityLabelFor(immStock);
        const formattedPercentageInWallet = percentageInWallet < 1 ? '< 1' : Math.round(percentageInWallet);
        const quoteObject = {
            amount: quote,
            currency: quoteCurrency
        };
        const quoteObjectEur = {
            amount: quoteEur,
            currency: quoteCurrencyEur
        };

        let parsedDate = this.buildFormattedQuoteDate(immStock);

        let formattedValue = HYPHEN;
        if (value && valueCurrency) {
            formattedValue = this.buildAmountCurrency(value, valueCurrency);
        }
        const quoteAmountBlock = this.buildQuoteAmount(quoteObject);

        const quoteValue = (
            <span className="broker-product-user-info__quote">
                {quoteAmountBlock}
            </span>
        );
        const quoteFullDate = (
            <span className="broker-product-user-info__quote-full-date">
                {parsedDate}
            </span>
        )
        let quoteTooltip;
        if (quote !== null) {
            quoteTooltip = (
                <OKTooltip
                    target={quoteValue}
                    content={quoteFullDate}
                    offset={[0, -15]}
                />);
        } else {
            quoteTooltip = quoteValue;
        }

        let averagePriceEurBlock;
        let formattedInvestmentEur;
        let quoteAmountEurBlock;
        let formattedValueEur;
        let formattedEarningsEur;
        let doubleRow = false;

        if (quoteCurrency !== EURO_TEXT && quoteCurrency) {
            formattedValueEur = HYPHEN;
            averagePriceEurBlock = this.buildAveragePriceEurLabelFor(immStock);
            formattedInvestmentEur = this.buildInvestmentEurLabelFor(immStock);
            quoteAmountEurBlock = this.buildQuoteAmountEur(quoteObjectEur);
            if (valueEur && valueCurrencyEur) {
                formattedValueEur = this.buildAmountCurrencyEur(valueEur, valueCurrencyEur);
            }
            formattedEarningsEur = this.buildProfitabilityEurLabelFor(immStock);
            doubleRow = true;
        }

        const inWalletClassNames = classnames( 'broker-product-user-info__value',
        {
            'broker-product-user-info__value-double': doubleRow,
        });


        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className={userValuesClassNames}>
                        <div className="col-xs-6 col-lg-3 broker-product-user-info__wrapper">
                            <div className="col-xs-6 col-lg-8 broker-product-user-info__contract">
                                <span className="broker-product-user-info__value">
                                    {contractForTooltip}
                                </span>
                            </div>

                            <div className="col-xs-6 col-lg-4 broker-product-user-info__titles">
                                <span className="broker-product-user-info__columnn-with-sign broker-product-user-info__value">
                                    {formattedShares}
                                </span>
                            </div>
                        </div>

                        <div className="col-xs-6 col-lg-3 broker-product-user-info__wrapper">
                            <div className="col-xs-6 col-lg-6 broker-product-user-info__half-price">
                                <span className="broker-product-user-info__value">
                                    <span className="broker-product-user-info__half-price">
                                        {averagePriceBlock}
                                    </span>
                                    <span className="broker-product-user-info__half-price-eur">
                                        {averagePriceEurBlock}
                                    </span>
                                </span>
                            </div>

                            <div className="col-xs-6 col-lg-6 broker-product-user-info__capital-invested">
                                <span className="broker-product-user-info__value">
                                    <span className="broker-product-user-info__investment">
                                        {formattedInvestment}
                                    </span>
                                    <span className="broker-product-user-info__investment-eur">
                                        {formattedInvestmentEur}
                                    </span>
                                </span>
                            </div>
                        </div>

                        <div className="col-xs-6 col-lg-5 broker-product-user-info__wrapper-quotation">
                            <div className="col-xs-6 col-lg-4 broker-product-user-info__quotation">
                                <span className="broker-product-user-info__value">
                                    {quoteTooltip}
                                    <span className="broker-product-user-info__quote-eur">
                                        {quoteAmountEurBlock}
                                    </span>
                                </span>
                            </div>

                            <div className="col-xs-6 col-lg-3 broker-product-user-info__actual-value">
                                <span className="broker-product-user-info__columnn-with-sign broker-product-user-info__value">
                                    <span className="broker-product-user-info__value">
                                        {formattedValue}
                                    </span>
                                    <span className="broker-product-user-info__value-eur">
                                        {formattedValueEur}
                                    </span>
                                </span>
                            </div>

                            <div className="col-xs-6 col-lg-5 broker-product-user-info__profitability">
                                <span className="broker-product-user-info__value">
                                    <span className="broker-product-user-info__earnings">
                                        {formattedEarnings}
                                    </span>
                                    <span className="broker-product-user-info__earnings-eur">
                                        {formattedEarningsEur}
                                    </span>
                                </span>
                            </div>
                        </div>

                        <div className="col-xs-6 col-lg-1 broker-product-user-info__in-wallet">
                            <span className={inWalletClassNames}>
                                {formattedPercentageInWallet}%
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    buildUserUnconsolidatedOperationsInfo(immStock) {
        const unconsolidatedOperationsTitle = formatText('broker-brokerUnconsolidatedOperationsExecuted');

        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className="broker-product-user-info__unconsolidated-operations">
                        <div className="col-xs-6 col-lg-3 broker-product-user-info__wrapper">
                            <div className="col-xs-6 col-lg-8 broker-product-user-info__contract">
                                <span className="broker-product-user-info__unconsolidated-operations-text">
                                    {unconsolidatedOperationsTitle}
                                    <OKTooltip
                                        content="broker-brokerUnconsolidatedOperationsTooltipText"
                                        offset={[0, -15]}
                                    />
                                </span>
                            </div>

                            <div className="col-xs-6 col-lg-4 broker-product-user-info__titles">
                                <span className="broker-product-user-info__unconsolidated-value">
                                    {this.buildUnconsolidatedOperationsShares(immStock)}
                                </span>
                            </div>
                        </div>
                        <div className="col-xs-6 col-lg-3 broker-product-user-info__wrapper"></div>
                        <div className="col-xs-6 col-lg-5 broker-product-user-info__wrapper-quotation">
                            <div className="col-xs-6 col-lg-4 broker-product-user-info__quotation"></div>
                            <div className="col-xs-6 col-lg-4 broker-product-user-info__actual-value">
                                <span className="broker-product-user-info__unconsolidated-value">
                                    {this.buildUnconsolidatedOperationsActualValue(immStock)}
                                </span>
                            </div>
                            <div className="col-xs-6 col-lg-4 broker-product-user-info__profitability"></div>
                        </div>

                        <div className="col-xs-6 col-lg-1 broker-product-user-info__in-wallet"></div>
                    </div>
                </div>
            </div>
        );
    }

    buildUserUnconsolidatedOperationsTotal(immStock) {
        const totalOperationsTitle = formatText('broker-brokerTotalOperations');

        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className="broker-product-user-info__total-unconsolidated-operations">
                        <div className="col-xs-6 col-lg-3 broker-product-user-info__wrapper">
                            <div className="col-xs-6 col-lg-8 broker-product-user-info__contract">
                                <span className="broker-product-user-info__unconsolidated-operations-text">
                                    {totalOperationsTitle}
                                </span>
                            </div>

                            <div className="col-xs-6 col-lg-4 broker-product-user-info__titles">
                                <span className="broker-product-user-info__columnn-with-sign broker-product-user-info__unconsolidated-total-value">
                                    {this.buildUnconsolidatedOperationsTotalShares(immStock)}
                                </span>
                            </div>
                        </div>
                        <div className="col-xs-6 col-lg-3 broker-product-user-info__wrapper"></div>
                        <div className="col-xs-6 col-lg-5 broker-product-user-info__wrapper-quotation">
                            <div className="col-xs-6 col-lg-4 broker-product-user-info__quotation"></div>
                            <div className="col-xs-6 col-lg-4 broker-product-user-info__actual-value">
                                <span className="broker-product-user-info__columnn-with-sign broker-product-user-info__unconsolidated-total-value">
                                    {this.buildUnconsolidatedOperationsTotalActualValue(immStock)}
                                </span>
                            </div>
                            <div className="col-xs-6 col-lg-4 broker-product-user-info__profitability"></div>
                        </div>

                        <div className="col-xs-6 col-lg-1 broker-product-user-info__in-wallet"></div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { immStock } = this.props;
        let content = [];

        if (immStock.size > 0){
            content.push(this.buildHeader());
            immStock.forEach((stock) => {
                const hasUnconsolidatedOperations = stock.getIn(['unconsolidatedOperations', 'hasUnconsolidatedOperations']);
                if ( hasUnconsolidatedOperations ) {
                    content.push(
                        this.buildUserInfo(stock),
                        this.buildUserUnconsolidatedOperationsInfo(stock),
                        this.buildUserUnconsolidatedOperationsTotal(stock)
                    );
                } else {
                    content.push(
                        this.buildUserInfo(stock)
                    );
                }
            });
        }

        return (
            <div customClassName="broker-product-user-info">
                {content}
            </div>
        );
    }
}

BrokerProductUserInfo.propTypes = {
    noBottomButtons: PropTypes.bool.isRequired,
    immStock: PropTypes.object.isRequired
};

module.exports = BrokerProductUserInfo;
